import { Injectable } from '@angular/core';
import { ModalController, LoadingController, AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class IonUtilititesService {

  private loader: any;

  constructor(
    public modalController: ModalController,
    private loadingController: LoadingController,
    private alertController: AlertController
  ) { }

  async openModal(component: any) {
    const modal = await this.modalController.create({
      component: component,
      backdropDismiss: false,
      cssClass: 'modal-css'
    });
    modal.present();
  }

  async presentAlert(message: string) {
    const alert = await this.alertController.create({
      message: message,
      buttons: ['OK']
    });

    await alert.present();
  }

  async presentLoading() {
    this.loader = await this.loadingController.create({});
    await this.loader.present();
  }

  dismissLoader() {
    this.loader.dismiss();
  }
}
